/**
 * Authentication utilities for Chat V2
 */

import { ensureFreshToken } from '@/config/keycloakClient'

/**
 * Get authentication token from Keycloak session
 * Always calls ensureFreshToken to handle expired tokens, not just missing ones
 */
export async function getAuthToken(): Promise<string | null> {
  return ensureFreshToken()
}
